module.exports = __webpack_public_path__ + "img/bgregister.c8dcf29b.png";